import React, { useEffect, useState } from "react";
import { Text, View, SafeAreaView, ScrollView } from "react-native";
import { firebase } from "../../../firebase";
import MemberListCard from "../components/MemberListCard";
import styles from "../styles/Styles";
import {withUserContext} from "../contexts/UserContext";

const Home = ({ navigation, global }) => {
  const [kids, setKids] = useState([]);
  const [parents, setParents] = useState([]);
  var kidsRef = firebase.database().ref("family/fid1/member/kids");
  var parentsRef = firebase.database().ref("family/fid1/member/parents");

  useEffect(() => {
    const handleData = (snap) => {
      if (snap.val()) {
        const json = snap.val();
        const kids = Object.values(json);
        setKids(kids);
      }
    };
    kidsRef.on("value", handleData, (error) => alert(error));
    return () => {
      kidsRef.off("value", handleData);
    };
  }, []);
  useEffect(() => {
    const handleData = (snap) => {
      if (snap.val()) {
        const json = snap.val();
        const parents = Object.values(json);
        setParents(parents);
      }
    };
    parentsRef.on("value", handleData, (error) => alert(error));
    return () => {
      parentsRef.off("value", handleData);
    };
  }, []);
  return (
    <View style={{ flex: 1 }}>
      <SafeAreaView style={styles.safeAreaContainer}>
        <ScrollView contentContainerStyle={styles.scrollViewContainer}>
          <Text style={styles.title}>Welcome to RUA, {global.name}!</Text>
          <Text style={styles.subtitle}>Last check-in: 3 days ago</Text>
          <Text style={styles.subtitle}>Your Families</Text>
          {global.role === "parents" ? (
            <MemberListCard
            style={styles.listTab}
            navigation={navigation}
            members={kids}
            />
          ) : null}
          {global.role === "kids" ? (
            <MemberListCard navigation={navigation} members={parents} />
          ) : null}
        </ScrollView>
      </SafeAreaView>
    </View>
  );
};

export default withUserContext(Home);
